import { QueryConfig } from "store/utils/query-config";

export const sessionsDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["metaData.lastOnline"]
  }
};
